<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card>
            <v-card-title class="text-h5 text-center pa-4">Şifremi Unuttum</v-card-title>
            <v-card-text>
              <v-alert v-if="message" :type="error ? 'error' : 'success'" dense class="mb-4">
                {{ message }}
              </v-alert>
  
              <v-form @submit.prevent="handleForgotPassword" ref="forgotPasswordForm" v-if="!success">
                <p class="mb-4">
                  Hesabınızla ilişkili e-posta adresini girin. Şifrenizi sıfırlamak için size bir bağlantı göndereceğiz.
                </p>
                <v-text-field
                  v-model="email"
                  label="E-posta Adresi"
                  type="email"
                  required
                  :rules="[rules.required, rules.email]"
                  prepend-icon="mdi-email"
                  :disabled="loading"
                ></v-text-field>
                <v-btn
                  type="submit"
                  color="primary"
                  block
                  large
                  class="mt-4"
                  :loading="loading"
                  :disabled="loading"
                >
                  Sıfırlama Bağlantısı Gönder
                </v-btn>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center pb-4">
               <v-btn small text color="primary" to="/login" class="pl-1">Giriş Sayfasına Dön</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import authService from '@/services/authService'; // Import your auth service
  
  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        loading: false,
        message: null,
        error: false,
        success: false, // To hide form on success
        rules: {
          required: value => !!value || 'Bu alan zorunludur.',
          email: value => /.+@.+\..+/.test(value) || 'Geçerli bir e-posta adresi girin.',
        },
      };
    },
    methods: {
      async handleForgotPassword() {
        this.message = null;
        this.error = false;
        this.success = false;
  
        const { valid } = await this.$refs.forgotPasswordForm.validate();
        if (valid) {
          this.loading = true;
          try {
            const response = await authService.forgotPassword({ email: this.email });
            this.message = response.data.message;
            this.error = false;
            this.success = true; // Hide form
          } catch (err) {
            this.error = true;
            this.message = err.response?.data?.message || 'Şifre sıfırlama isteği gönderilirken bir hata oluştu.';
            console.error('Forgot password error:', err);
          } finally {
            this.loading = false;
          }
        }
      },
    },
  };
  </script>
  